module.exports = __webpack_public_path__ + "static/media/19ESCAP35.28340127.jpg";